import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'

import { getMedia, getCount } from '../store/reducers/news'


const NewsPage = ({ items = [],}) => {
  if (!items.length) return null


  return (

    //<div className='Persons'>
    <div className='Container'>
    <section className='Persons__section'>
    <h1 className='Persons__header bottom-space'>
        <FormattedMessage id='header.massmedia' />
    </h1>

    <div className='Persons__list'>
    
    {items.map(data => (
          <article key={data._id} className='Lot' style={{ verticalAlign: "top"}}>
                <span className='News__item-img-wrap' style={{ height: "200px"}}>
                  <div className='mediaText' style={{opacity: "1%", width: "100%", height: "100%", position:"absolute", zIndex: "1"}}>
                    <span style={{ display: "table-cell", width: "100%", marginTop:"45%", position: "absolute"}}>{data.mediaName}</span>
                  </div>
                  <img className='Lot__img' style={{widht: "100%"}} src={data.image} alt={data.title} />
                </span>
              <div className='Small' style={{textAlign:"center", lineHeight: "1.1", marginTop: "15px"}}><i>{data.title}</i></div>
        </article>
        ))}
    </div>
  
  </section>
  </div>
  )
}

const mapStateToProps = state => ({ ...state.news })
const mapDispatchToProps = dispatch => bindActionCreators({ getMedia, getCount }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({}),
  lifecycle({
    componentWillMount () {
      this.props.getMedia()
      this.props.getCount()
    }
  })
)(NewsPage)



// WEBPACK FOOTER //
// ./src/containers/Massmedia.jsx